import { createContext, type FC, type ReactNode } from 'react';
import type { PriceDeckFormInstance, PriceDeckFormMode } from './types';

export interface PriceDeckFormContextValue {
  form: PriceDeckFormInstance;
  mode: PriceDeckFormMode;
  deckId: string | null;
}

export const PriceDeckFormCtx = createContext<PriceDeckFormContextValue | null>(
  null
);

interface PriceDeckFormProviderProps {
  form: PriceDeckFormInstance;
  mode: PriceDeckFormMode;
  deckId: string | null;
  children: ReactNode;
}

/**
 * Provides the TanStack Form instance, mode, and deck ID to all form children.
 * @param {PriceDeckFormProviderProps} props - Form instance, mode, deckId, and children.
 * @return {JSX.Element} The context provider.
 */
export const PriceDeckFormProvider: FC<PriceDeckFormProviderProps> = ({
  form,
  mode,
  deckId,
  children,
}) => (
  <PriceDeckFormCtx.Provider value={{ form, mode, deckId }}>
    {children}
  </PriceDeckFormCtx.Provider>
);
